module.exports = __webpack_public_path__ + "static/assets/291f15213be01a3ebdae5c547833c0d5.png";